import { createEnum } from "../../../utils/utils";

export const ReportingOptionEnum = createEnum({
  // ANONYMOUS: "Report Anonymously",
  IDENTIFIED_CLIENT: "Report on your behalf",
  ON_BEHALF_OF: "Report on behalf of someone else",
});

export const BlockChainTypeEnum = createEnum({
  BTC: "Bitcoin",
  ETH: "Ethereum",
  LTC: "Litecoin",
  ADA: "Cardano",
  SOL: "Solana",
  DOT: "Polkadot",
  BNB: "Binance",
  XRP: "Ripple",
});

export const TypeOfFraudEnum = createEnum({
  HACKED_WALLET_SEEDS: "Hacked wallet seeds",
  RUG_PULL: "Rug Pull",
  TRICKED: "Got Tricked in sending money",
  OTHER: "Other",
});

export const TokenLifecycleEnum = createEnum({
  PRIVATE_SALE: "Private Sale",
  PRE_SALE: "Pre-Sale",
  PUBLIC_SALE: "Public Sale",
  LAUNCH: "Launch",
  PRODUCTION: "Production",
});

export const FundsTypeEnum = createEnum({
  PERSONAL: "Personal funds?",
  CORPERATE: "Corporate funds?",
});

export const SocialMediaEnum = createEnum({
  WEBSITE: "Website",
  WHATSAPP: "Whatsapp",
  FACEBOOK: "Facebook",
  TELEGRAM: "Telegram",
  MEDIUM: "Medium",
  TWITTER: "Twitter",
  REDDIT: "Reddit",
});

export interface FraudReportTransaction {
  transactionDate: Date | null;
  reference: string;
}

export interface FraudReportSocialMedia {
  type: typeof SocialMediaEnum.T;
  value: string;
}

export interface FraudReportAttachments {
  id: string;
  attachedDate: string;
}
